import type { FaireProductEntity } from "../../entity_types/product";

export const p_9knaujwjm2: FaireProductEntity = {
  token: "p_9knaujwjm2",
  type: "product",
  name: "Fawn Cardigan Sweater for Baby & Toddler",
  brandToken: "b_e6gi5qy7n8",
  brandName: "Huggalugs",
  imageUrl:
    "https://cdn.faire.com/fastly/a2ee452896cc7a0d2fc788795f615a1f41cd8e712abc3cc2570dee221ad6166e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/08fcb03f2fcbe02db06021427328e1c091dc508ccd762e8a7df19c00eeb5c2dd.jpeg",
    "https://cdn.faire.com/fastly/036b1d03f9c07c8d01715f1681fdea4cb62a3eeec0d978eeecfdd9a7a4497421.png",
  ],
  priceDollars: 24,
  description:
    "This snuggly hand‑knit Fawn cardigan brings extra charm with two adorable fawn‑face pockets peeking out up front. Made from soft, chunky yarn and finished with natural wood buttons, it’s as cozy as it is cute. Pair it with our Fawn Beanie Hat for the ultimate woodland‑cutie outfit that’s guaranteed to spark smiles\n\nOur sweaters are crafted using recycled, sustainable polyester yarn spun from reclaimed plastic bottles, a thoughtful choice that helps lessen global plastic waste. It’s one small way we’re contributing to a cleaner, more sustainable world. ♻️\n\n• Hand Knit\n• 60% Acrylic, 40% Recycled Polyester\n• Hand Wash\n• Designed in our Coachella Valley, CA studio\n",
  tags: [],
  msrpDollars: 48,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:54.086Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
